export default __webpack_public_path__ + "static/media/closed.35f242b4.png";